import styled from 'styled-components';

import { theme } from '../../../common/ui/theme';

export const OptionButton = styled.button<{ $selected?: boolean; $hasOverride?: boolean; $highlighted?: boolean }>`
    align-items: center;
    background: ${(props) => (props.$highlighted ? theme.colors.accent.background : theme.colors.background.default)};
    border: none;
    border-radius: ${theme.radii[4]};
    color: ${(props) =>
        props.$selected && props.$hasOverride ? theme.colors.accent.foreground : theme.colors.foreground.default};
    cursor: pointer;
    display: grid;
    font-feature-settings: inherit;
    font-size: ${theme.fontSizes[14]};
    font-weight: ${theme.fontWeights[500]};
    gap: ${theme.space[8]};
    grid-template-columns: minmax(0, 1fr) minmax(${theme.space[16]}, auto);
    flex: none;
    height: ${(props) => (props.$hasOverride ? 'auto' : '32px')};
    min-height: 32px;
    line-height: 20px;
    padding: 0 ${theme.space[8]};
    text-align: left;
    width: 100%;

    &:hover,
    &:focus-visible {
        background: ${(props) =>
            props.$selected || props.$highlighted ? theme.colors.accent.background : theme.colors.background.inset};
        outline: none;
    }

    &:disabled {
        color: ${theme.colors.foreground.disabled};
        cursor: default;
    }
`;
